export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  avatarSyle: {
    fontSize: "1.2em"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    flex: 1
  },
  booleanFieldStyle: {
    margin: 0
  }
};

export const formStyle = {
  titleStyle: {
    textTransform: "capitalize"
  },
  clearFloatContainer: {
    clear: "both"
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/Suppressions/style.js